<template>
    <sa-page-layout :btnNewVisible="false" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovoProgetto">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-body">
            <pazienti-progetti-list-component ref="PazientiProgettiListComponent" @afterLoadData="onAfterLoadData"></pazienti-progetti-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import PazientiProgettiListComponent from "../components/PazientiProgettiListComponent.vue";

export default {
    components: { SaPageLayout, PazientiProgettiListComponent },
    data() {
        return {
            btnNewVisible: true,
            pathResource: "",
            linkedit: "/graffidiapplicativi",
            showModalLoading: false,
            listKey: 0,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.PazientiProgettiListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onClickNuovoProgetto() {
            this.$refs.PazientiProgettiListComponent.onClickNuovoProgetto();
        },
    },
};
</script>

<style></style>
